import { VALAQUENTA_API_URL } from "../..";
import { authorizedAxios, loggingAxios } from "../../../App";
export function fetchFerryReservations({ params }) {
  return authorizedAxios.get(
    `${VALAQUENTA_API_URL}/crs/internal/reservations/ferry/`,
    {
      params,
    }
  );
}

export function retrieveFerryReservation({ reference }) {
  return authorizedAxios.get(
    `${VALAQUENTA_API_URL}/crs/internal/reservations/ferry/${reference}/`
  );
}
export async function patchFerryReservation({ reference, payload }) {
  return await loggingAxios.patch(
    `${VALAQUENTA_API_URL}/crs/internal/reservations/ferry/${reference}/`,
    payload
  );
}
export function getFerryReservationStats({ params }) {
  return authorizedAxios.get(
    `${VALAQUENTA_API_URL}/crs/internal/reservations/ferry/stats/`,
    { params }
  );
}
